'use strict';

var React = require('react'),
    { Route, DefaultRoute, Redirect } = require('react-router'),
    AboutPage = require('./pages/AboutPage'),
    TermsPage = require('./pages/TermsPage'),
    PrivacyPage = require('./pages/PrivacyPage'),
    loadEditorChunk = require('promise?global,editor!./chunks/editor'),
    loadStampChunk = require('promise?global,stamp!./chunks/stamp'),
    HomePage = require('./pages/HomePage'),
    FeedPage = require('./pages/FeedPage'),
    SearchPage = require('./pages/SearchPage'),
    UserPage = require('./pages/UserPage'),
    ZinePage = require('./pages/ZinePage'),
    NewZinePage = require('./pages/NewZinePage'),
    ListedZinesPage = require('./pages/ListedZinesPage'),
    StampPageMixins = require('./mixins/StampPageMixins'),
    createAsyncPage = require('./pages/createAsyncPage'),
    App = require('./App');

function makeAsyncEditorHandler(key) {
  return createAsyncPage(function () {
    return loadEditorChunk().then(chunk => chunk[key]);
  }, key);
}

function makeAsyncStampHandler(routeName, stampPageMixin) {
  return createAsyncPage(function () {
    return loadStampChunk().then(function (stampChunk) {
      return stampChunk.createStampPage({
        routeName: routeName,
        stampPageMixin: stampPageMixin
      });
    });
  }, routeName);
}

function makeStampRoute(routeName, stampPageMixin, path) {
  return (
    <Route name={routeName}
           path={path}
           handler={makeAsyncStampHandler(routeName, stampPageMixin)} />
  );
}

module.exports = (
  <Route handler={App} fillHeight>
    <Route name='home' path='/' handler={HomePage}>
      <Route name='feed' path='/' handler={FeedPage} />
    </Route>

    <Route name='zines' path='/collections' handler={ListedZinesPage} />

    <Route name='search' path='/search' handler={SearchPage} />

    <Route name='about' path='/about' handler={AboutPage} />

    <Route name='terms' path='/terms' handler={TermsPage} />
    <Route name='privacy' path='/privacy' handler={PrivacyPage} />

    <Route path='/draft/:stampSegment' handler={makeAsyncEditorHandler('DraftPage')}>
      <Route name='draftCompose' path='edit' handler={makeAsyncEditorHandler('DraftComposePage')} />
      <DefaultRoute name='draftPreview' handler={makeAsyncEditorHandler('DraftPreviewPage')} />
    </Route>
    <Redirect from='/editor/new' to='/draft/new/edit' />
    <Redirect from='/editor' to='/draft/new/edit' />

    <Route path='/stamp/:stampSegment/edit' handler={makeAsyncEditorHandler('DraftPage')}>
      <DefaultRoute name='stampEditCompose' handler={makeAsyncEditorHandler('DraftComposePage')} />
      <Route name='stampEditPreview' path='preview' handler={makeAsyncEditorHandler('DraftPreviewPage')} />
    </Route>

    <Route name='user' path='/user/:userId' handler={UserPage} />
    <Redirect from='/user/:userId/latest' to='user' />
    <Redirect from='/user/:userId/likes' to='user' />
    <Redirect from='/user/:userId/curated' to='user' />

    {makeStampRoute('feedStamp', StampPageMixins.Feed, '/stamp/:stampSegment')}
    {makeStampRoute('userLatestStamp', StampPageMixins.UserLatest, '/user/:userId/latest/:stampSegment')}
    {makeStampRoute('userLikedStamp', StampPageMixins.UserLiked, '/user/:userId/likes/:stampSegment')}
    {makeStampRoute('zineLatestStamp', StampPageMixins.ZineLatest, '/:zineSlug/latest/:stampSegment')}
    {makeStampRoute('zinePendingStamp', StampPageMixins.ZinePending, '/:zineSlug/pending/:stampSegment')}
    <Redirect from='/feed/:stampSegment' to='feedStamp' />
    <Redirect from='/feed/:zineSlug/:stampSegment' to='feedStamp' />
    <Redirect from='/top/:stampSegment' to='feedStamp' />
    <Redirect from='/trending/:stampSegment' to='feedStamp' />
    <Redirect from='/:zineSlug/trending/:stampSegment' to='zineLatestStamp' />

    <Route name='zine' path='/:zineSlug' handler={ZinePage} />
    <Route name='zineNew' path='/collections/new' handler={NewZinePage} />
    <Redirect from='/:zineSlug/trending' to='zine' />
    <Redirect from='/:zineSlug/latest' to='zine' />
    <Redirect from='/:zineSlug/pending' to='zine' />
  </Route>
);



/** WEBPACK FOOTER **
 ** ./routes.js
 **/